import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTableGrid = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.5em",
	height: "2.5em",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10 16H30",
			stroke: "#281E38",
			strokeWidth: 1.6667,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 23H30",
			stroke: "#281E38",
			strokeWidth: 1.6667,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0002 10V30",
			stroke: "#281E38",
			strokeWidth: 1.6667,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 30H12C11.4696 30 10.9609 29.7893 10.5858 29.4142C10.2107 29.0392 10 28.5305 10 28V12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10H28C28.5305 10 29.0392 10.2107 29.4142 10.5858C29.7893 10.9609 30 11.4696 30 12V28C30 28.5305 29.7893 29.0392 29.4142 29.4142C29.0392 29.7893 28.5305 30 28 30Z",
			stroke: "#281E38",
			strokeWidth: 1.6667,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgTableGrid);
export default ForwardRef;
